export default IconEscalatorDown => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-escalator-down" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4.5 7h2.733a2 2 0 0 1 1.337 .513l9.43 8.487h1.5a2.5 2.5 0 1 1 0 5h-2.733a2 2 0 0 1 -1.337 -.513l-9.43 -8.487h-1.5a2.5 2.5 0 1 1 0 -5z" />
  <path d="M18 3v7" />
  <path d="M15 7l3 3l3 -3" />
</svg>`;